import React from "react";
import LoginComponent from "../components/LoginComponent";

const Login = () => {
  return (
    <div>
      <LoginComponent />
    </div>
  );
};

export default Login;
